import { Component,OnInit,OnChanges, SimpleChanges } from '@angular/core';
import { LtmsEventHandlerService } from '../../services/ltms-event-handler/ltms-event-handler.service';
import { ActivatedRoute, UrlSegment } from '@angular/router';
import { LoginService } from '../../services/login/login.service';
import { HelpersService } from '../../services/helpers/helpers.service';
import * as _ from 'lodash';
import { FeedDetailPanelComponent } from '../feed-detail-panel/feed-detail-panel.component';
import { LtmsLoaderComponent } from '../ltms-loader/ltms-loader.component';
import { NgIf } from '@angular/common';
@Component({
    selector: 'app-feed-details-view',
    templateUrl: './feed-details-view.component.html',
    styleUrl: './feed-details-view.component.scss',
    imports: [FeedDetailPanelComponent,LtmsLoaderComponent,NgIf]
})
export class FeedDetailsViewComponent implements OnInit,OnChanges {
  isAuthenitcated:boolean = false
  loading:boolean = true;
  constructor(
    private _ltmsEvents:LtmsEventHandlerService,
    private _route: ActivatedRoute,
    private _loginService:LoginService,
    private _helpers:HelpersService
  ){}

  ngOnInit(): void {
    this.authenticateUser().then((isAuthenitcated:any)=>{
      window['Helpers'] = this._helpers.consoleData();
      isAuthenitcated = (isAuthenitcated == true)? true:false;
      this.isAuthenitcated = isAuthenitcated;
      this._route.queryParams.subscribe(params => {
        const feedId = params['feed_id'];
        this.showFeedDetails(feedId, isAuthenitcated);
      });
    })
    
  }
  ngOnChanges(changes: SimpleChanges): void {
    
  }

  authenticateUser(){
    return new Promise((resolve)=>{
      this._loginService.checkUserIsLoggedIn().subscribe((response:any)=>{
        if( (response.code === 0) && _.hasIn(response,'data.isManagerLoggedIn') && _.get(response,'data.isManagerLoggedIn',false)){
        resolve(true)
        }else{
          resolve(false)
        }
      })
    })
  }

  showFeedDetails(feedId:string,isAuthenitcated:boolean){
    if(isAuthenitcated){
      this.loading = false
      setTimeout(() => {
        this._ltmsEvents.emit('feed-detail-panel',  {
          feed_id:feedId,
          feedIdList:[],
          pagingDetails:{
            start: 0,
            end: 0,
            pageSize: 10,
            pageNumber: 1,
            total: 0,
            totalpages: 1
          }
        })
      }, 1000);
    }else{
      this.loading = false;
      const redirectDetails:any={
        redirectUrl:'/feed',
        redirectParams:{
          feed_id:feedId
        }
      }
      this._loginService.gotoLogin(redirectDetails)
    }
  }

}
